import script from "./previewOtherProforma.vue?vue&type=script&setup=true&lang=js"
export * from "./previewOtherProforma.vue?vue&type=script&setup=true&lang=js"

import "./previewOtherProforma.vue?vue&type=style&index=0&id=58eea766&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58eea766"]])

export default __exports__